import { Injectable } from '@angular/core';
import { UrlHandlingStrategy, UrlTree } from '@angular/router';

@Injectable()
export class DiagramEditorUrlHandlingStrategy implements UrlHandlingStrategy {
    shouldProcessUrl(url: UrlTree): boolean {
        const urlString = url.toString();
        // /assets ile başlayan yolların router tarafından işlenmesini engelle
        if (urlString.startsWith('/assets/htmlcontent/diagrameditor')) {
            return false;
        }
        return true;
    }

    extract(url: UrlTree): UrlTree {
        return url;
    }

    merge(newUrlPart: UrlTree, rawUrl: UrlTree): UrlTree {
        return newUrlPart;
    }
}
